/**
 * @file: Carousel.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 轮播图管理
 */
import request from '@/utils/request'

/**
 * 新增轮播图
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function carouselAdd(data) {
  return request({
    type: 'biz',
    url: 'carousel/add',
    method: 'post',
    data
  })
}

/**
 * 删除轮播图
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function carouselDelete(data) {
  return request({
    type: 'biz',
    url: 'carousel/delete',
    method: 'post',
    data
  })
}

/**
 * 获取轮播图详情
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function carouselGet(data) {
  return request({
    type: 'biz',
    url: 'carousel/get',
    method: 'post',
    data
  })
}

/**
 * 轮播图列表(分页)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function carouselPageListGet(data) {
  return request({
    type: 'biz',
    url: 'carousel/page/list/get',
    method: 'post',
    data
  })
}

/**
 * 修改轮播图
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function carouselUpdate(data) {
  return request({
    type: 'biz',
    url: 'carousel/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Carousel.js